import io, { Socket } from "socket.io-client";
import { AppSettings } from "@/store";

let socket: Socket | null = null;

function connect() {
  if (!socket) {
    socket = io(AppSettings.messageWebSocket);

    socket.on("connect", () => {
      console.log("Connected to server");
    });

    socket.on("connect_error", (error) => {
      console.error("Socket connection error:", error);
    });
  } else if (!socket.connected) {
    socket.connect();
  }
}

function disconnect() {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}

function getSocket(): Socket | null {
  return socket;
}

export default {
  connect,
  disconnect,
  getSocket,
};
